4<template>
    <div class="container">
        <div class="row mt-3">
            <div class="col">
                <h2>{{ data.name }}</h2>
            </div>
            <div class="col" v-if="data.user.level <= 10">
                <div class="float-top float-end">
                    <div class="dropdown">
                        <button class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown" type="button" id="dropdownMenuButton">
                            Åtgärder
                        </button>
                        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
                            <li v-if="data.user.level <= 10">
                                <button class="btn btn-link dropdown-item" @click="showImportReadingsModal">
                                    Importera avläsningar
                                </button>
                            </li>
                            <li v-if="data.user.level === 1">
                                <button class="btn btn-link dropdown-item" @click="showApartmentModal(null)">
                                    Lägg till mätplats
                                </button>
                            </li>
                            <li v-if="data.user.level === 1">
                                <button class="btn btn-link dropdown-item" @click="showBaseDataImportModal">
                                    Importera grunddata
                                </button>
                            </li>
                            <li v-if="data.user.level === 1">
                                <button class="btn btn-link dropdown-item" @click="showImportModal">
                                    Importera mätarlista
                                </button>
                            </li>
                            <li v-if="data.user.level === 1">
                                <button class="btn btn-link dropdown-item" @click="exportBaseDataToFile">
                                    Exportera grunddata
                                </button>
                            </li>
                            <li v-if="data.user.level === 1">
                                <button class="btn btn-link dropdown-item" @click="exportToFile">
                                    Exportera mätarlista
                                </button>
                            </li>
                            <li v-if="data.user.level === 1">
                                <button class="btn btn-link dropdown-item" @click="apiKeysModal.show()">
                                    API-nycklar
                                </button>
                            </li>
                            <li v-if="data.user.level === 1">
                                <button class="btn btn-link dropdown-item" @click="showUploadDocumentModal">
                                    Ladda upp dokument
                                </button>
                            </li>
                            <li v-if="data.user.level === 1">
                                <button class="btn btn-link dropdown-item" @click="exportOneReaderMeterListToFile">
                                    OneReader mätarlista
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="data.user.level <= 10 && data.warnings.length > 0" class="alert alert-warning alert-dismissible">
            <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
            <strong>Varningar</strong>
            <ul>
                <li v-for="warning in data.warnings">{{ warning }}</li>
            </ul>            
        </div>
        <ul class="nav nav-tabs">
            <li class="nav-item">
                <button id="dashboard" class="btn btn-link nav-link active" @click="goToTab('dashboard')">Översikt</button>
            </li>
            <li class="nav-item">
                <button id="devices" class="btn btn-link nav-link" @click="goToTab('devices')">Mätare</button>
            </li>
            <li class="nav-item">
                <button id="statistics" class="btn btn-link nav-link" @click="goToTab('statistics')">Statistik</button>
            </li>
            <li class="nav-item" v-show="data.user.level <= 10 || data.properties.customer_alarms">
                <button id="alarms" class="btn btn-link nav-link" @click="goToTab('alarms')">Larm</button>
            </li>
            <li class="nav-item" v-show="data.user.level <= 10 || data.properties.customer_reports">
                <button id="reports" class="btn btn-link nav-link" @click="goToTab('reports')">Rapporter</button>
            </li>
            <li class="nav-item" v-show="data.user.level <= 10 || data.properties.customer_billing">
                <button id="billing" class="btn btn-link nav-link" @click="goToTab('billing')">Avräkning</button>
            </li>
            <li class="nav-item" v-show="data.properties.show_document_tabs">
                <button id="control-reports" class="btn btn-link nav-link" @click="goToTab('control-reports')">Kontrollrapporter</button>
            </li>
            <li class="nav-item" v-show="data.properties.show_document_tabs">
                <button id="certificates" class="btn btn-link nav-link" @click="goToTab('certificates')">Kalibreringsintyg</button>
            </li>
            <li class="nav-item">
                <button id="imports" class="btn btn-link nav-link" @click="goToTab('imports')">Importlogg</button>
            </li>
        </ul>
        <div>
            <SiteOverview v-if="data.tab === 'dashboard'" :config="data.reportingStatus" />
            <Devices v-if="data.tab === 'devices'" :apartments="data.apartments" :buildingTypes="data.apartmentBuldingTypes"
                @reload="reload" @show-statistics="onShowStatistics" @show-device-readings="onShowDeviceReadings"
            />
            <Statistics v-if="data.tab === 'statistics'" :form="statisticsData" :apartments-data="data.apartments" />
            <Reports v-if="data.tab === 'reports'" />
            <div v-if="data.tab === 'billing'">
                <div v-if="data.user.level > 10 && data.properties.customer_reports" class="container tab-panel p-3">
                    <div class="alert alert-info alert-dismissible">
                        <div><strong>Avräkning</strong> har flyttats till fliken <strong>Rapporter</strong>. Välj där en av Förbrukningsrapport-mallarna.</div>
                        <div class="mt-2">Uppmärksamma att stopp-datum här är inklusivt, till skillnad från hur det var i avräkningarna. Så vill man ha förbrukningen för januari 2026, så väljer man från 2026-01-01 till 2026-01-31.</div>
                    </div>
                </div>
                <Billing v-else :apartments="data.apartments" :siteName="data.name" />
            </div>
            <Alarms v-if="data.tab === 'alarms'" :apartments="data.apartments" @show-device="onShowDeviceReadings" @show-statistics="onShowStatistics"/>
            <Imports v-if="data.tab === 'imports'" :site-id="importLogData.siteId" :start="importLogData.start" :stop="importLogData.stop" />
            <Documents v-if="data.tab === 'control-reports'" :data="reportsData" @reload="loadDocuments" />
            <Documents v-if="data.tab === 'certificates'" :data="certificatesData" @reload="loadDocuments" />
        </div>
        <ApiKeysModal id="apiKeysModal" :site-id="data.siteId" @close="apiKeysModal.hide()" />
        <ImportDevices id="importModal" :data="importFileData" @close="importModal.hide()" @submit="resultModal.show()" @reload="reload" />
        <ImportResults id="resultModal" :data="importFileData" @close="resultModal.hide()" />
        <ApartmentForm id="apartmentModal" :data="apartmentData" :buildingTypes="data.apartmentBuldingTypes" @close="apartmentModal.hide()" @submit="reload" />
        <ReadingsModal id="readingsModal" ref="readingsModalRef" :data="readingsData" :apartments="data.apartments" 
            @close="readingsModal.hide()" @update="onReadingsUpdate" @change-apartment="onReadingsChangeApartment" @reload="reload" />
        <ImportReadingsModal id="importReadingsModal" :data="importReadingsData" @close="importReadingsModal.hide()" @reload="reload" />
        <UploadDocumentModal id="uploadDocumentModal" :data="uploadDocumentData" @close="uploadDocumentModal.hide()" @reload="loadDocuments" />
        <BaseDataImportModal id="baseDataImportModal" :data="baseData" @close="baseDataImportModal.hide()" @reload="reload" />
    </div>
</template>

<script setup>
import { ref, reactive, onMounted, defineAsyncComponent } from 'vue'
import { useRoute } from 'vue-router'
import { Modal } from 'bootstrap'
import writeXlsxFile from 'write-excel-file'
// Serives
import sitesService from '@/services/sitesService'
import tokenService from '@/services/tokenService'
import readingsService from '@/services/readingsService'
import documentsService from '@/services/documentsService'
// Components
import ApartmentForm from '@/components/ApartmentModal.vue'
import ImportDevices from '@/components/ImportDevicesModal.vue'
import ImportResults from '@/components/ImportResultsModal.vue'
import ApiKeysModal from '@/components/ApiKeysModal.vue'
import Reports from '@/components/Reports.vue'
import Alarms from '@/components/Alarms.vue'
import Statistics from '@/components/Statistics.vue'
import SiteOverview from '@/components/SiteOverview.vue'
import ReadingsModal from '@/components/ReadingsModal.vue'
import ImportReadingsModal from '@/components/ImportReadingsModal.vue'
import Documents from '@/components/Documents.vue'
import UploadDocumentModal from '@/components/UploadDocument.vue'
import BaseDataImportModal from '@/components/BaseDataImportModal.vue'
// Helpers
import devicesHelpers from '@/helpers/devicesHelpers'
import helpers from '@/helpers/helpers'
import seriesHelpers from '@/helpers/seriesHelpers'
import dateTime from '@/helpers/dateTime'

const Devices = defineAsyncComponent(
    () => import('../components/Devices.vue')
)

const Billing = defineAsyncComponent(
    () => import('../components/Billing.vue')
)

const Imports = defineAsyncComponent(
    () => import('../components/ImportLog.vue')
)

const route = useRoute()

let apiKeysModal = ref(null)
let importModal = ref(null)
let resultModal = ref(null)
let apartmentModal = ref(null)
let readingsModal = ref(null)
let importReadingsModal = ref(null)
let uploadDocumentModal = ref(null)
let baseDataImportModal = ref(null)
const readingsModalRef = ref(null)

const data = reactive({
    siteId: null, 
    name: null,
    properties: {},
    tab: 'dashboard', // Default active tab in template
    user: {},
    apartments: [],
    warnings: [],
    reportingStatus: [],
    hasCertificates: false,
    documents: [],
})

const importFileData = reactive({})
const apartmentData = reactive({})
const importLogData = reactive({})
const readingsData = reactive({
    apartmentId: null,
    deviceId: null,
    start: null,
    stop: null,
    devices: [],
    readings: [],
    hasMore: false,
    fields: [],
    mpFields: [],
})
const reportsData = reactive({ documents: [], period: 'all', type: 'all', types: [] })
const certificatesData = reactive({ documents: [], period: 'all', type: 'all', types: [] })
const baseData = reactive({
    siteId: null,
    diff: [],
    readyToApply: false,
    changes: [],
    fileInputKey: 0,
})

readingsData.start = dateTime.floor(new Date(), 'day')
readingsData.stop = dateTime.ceil(new Date(), 'day')

const statisticsData = reactive({
    site: null,
    apartment: null,
    mp: null,
    field: null,
    period: null,
    date: null,
    year: null,
    month: null,
    week: null,
    periods: null,
})

const allPeriods = [
    { minutes: 15, value: '15minsDay', label: '15 min. / dygn' },
    { minutes: 60, value: 'hoursDay', label: 'timmar / dygn' },
    { minutes: 60, value: 'hoursWeek', label: 'timmar / vecka' },
    { minutes: 24 * 60 * 7, value: 'daysWeek', label: 'dagar / vecka' },
    { minutes: 24 * 60, value: 'daysMonth', label: 'dagar / månad' },
    { minutes: 24 * 60 * 30, value: 'monthsYear', label: 'månader / år' },
]

const importReadingsData = reactive({
    enableAdvanced: false,
    showAdvanced: false,
    columns: '',
    errorMessage: null,    
    successMessages: null,
})

const uploadDocumentData = reactive({
    siteId: null, 
    emailAddresses: null,
    period: null,
    category: null,
    subCategory: null,
    missingPeriod: false,
    missingCategory: false,
    missingSubCategory: false,
    sendEmail: true,
    noFileSelected: false,
    errorMessage: null,    
    successMessages: null,
})

function showImportReadingsModal() {
    importReadingsData.enableAdvanced = data.user.level === 1
    importReadingsData.showAdvanced = false
    importReadingsData.columns = ''
    importReadingsData.errorMessage = null
    importReadingsData.successMessages = null
    importReadingsModal.show()
}

async function showUploadDocumentModal() {
    uploadDocumentData.siteId = data.siteId
    uploadDocumentData.period = null
    uploadDocumentData.category = null
    uploadDocumentData.subCategory = null
    uploadDocumentData.sendEmail = false
    uploadDocumentData.missingPeriod = false
    uploadDocumentData.missingCategory = false
    uploadDocumentData.missingSubCategory = false
    uploadDocumentData.noFileSelected = false
    uploadDocumentData.errorMessage = null
    uploadDocumentData.successMessages = null

    const users = (await documentsService.getDocumentUsers(data.siteId)).data
    const recipients = []
    for (const u of users) {
        if (u.email) {
            recipients.push(`${u.name} (${u.email})`)
        }
    }
    uploadDocumentData.emailAddresses = recipients.join(', ')

    uploadDocumentModal.show()    
}

function showImportModal() {
    importFileData.siteId = data.siteId
    importFileData.errors = []
    importFileData.changes = []
    importFileData.fileInputKey = Date.now() // To reset file input
    importModal.show()
}

function showBaseDataImportModal() {
    baseData.siteId = data.siteId
    baseData.errors = []
    baseData.changes = []
    baseData.diff = []
    baseData.readyToApply = false
    baseData.errorLines = []
    baseData.errorMessage = null
    baseData.successMessages = null
    baseData.fileInputKey = Date.now() // To reset file input
    baseDataImportModal.show()
}

function goToTab(tab) {
    let oldTab = document.getElementById(data.tab)
    oldTab.classList.remove('active')
    let newTab = document.getElementById(tab)
    newTab.classList.add('active')
    data.tab = tab
}

function onShowStatistics(args) {
    const apartment = data.apartments.find(a => a.id == args.apartment)
    if (!apartment) {
        return
    }
    
    const mp = apartment.devices.find(d => d.measuringPointId == args.mp)
    if (!mp) {
        return
    }

    statisticsData.apartment = args.apartment
    statisticsData.mp = args.mp
    if (args.field) {
        statisticsData.field = args.field
    } else {
        statisticsData.field = seriesHelpers.getMeasurementDefaultField(mp.measurement)
    }
    goToTab('statistics')
}

function showApartmentModal(apartmentId) {
    if (apartmentId) {
        const apartment = data.apartments.find(a => a.id == apartmentId)
        apartmentData.siteId = data.siteId
        apartmentData.id = apartment.id
        apartmentData.number = apartment.number
        apartmentData.address = apartment.address
        apartmentData.type = apartment.type
        apartmentData.externalNumber = apartment.extra?.externalNumber
        apartmentData.buildingType = apartment.extra?.buildingType
        apartmentData.share = apartment.extra?.share ? String(apartment.extra?.share).replace('.', ',') : null
        apartmentData.buildingTypes = data.apartmentBuldingTypes
    } else {
        apartmentData.siteId = data.siteId
        apartmentData.id = null
        apartmentData.number = null
        apartmentData.address = null
        apartmentData.type = null
        apartmentData.externalNumber = null
        apartmentData.buildingType = null
        apartmentData.share = null
        apartmentData.buildingTypes = data.apartmentBuldingTypes
    }
    apartmentModal.show()
}

async function reload() {
    const result = await devicesHelpers.loadDevices(data.siteId)
    data.apartments = result.apartments
    data.reportingStatus = result.statusConfig
    data.warnings = result.warnings ?? []
    data.apartmentBuldingTypes = result.apartmentBuldingTypes ?? []

    let minFreqMinutes = 60 * 24
    switch (data.properties.max_stats_resolution ?? 'hour') {
        case '15min':
            minFreqMinutes = 15
            break
        case 'hour':
            minFreqMinutes = 60
            break
        case 'day':
            minFreqMinutes = 60 * 24
            break
        case 'week':
            minFreqMinutes = 60 * 24 * 7
            break
        case 'month':
            minFreqMinutes = 60 * 24 * 30
            break
        case 'year':
            minFreqMinutes = 60 * 24 * 365
            break
    }
    const periods = []
    for (const period of allPeriods) {
        if (period.minutes >= minFreqMinutes) {
            periods.push(period)
        }
    }
    statisticsData.periods = periods
}

async function exportToFile() {
    const bom = '\uFEFF'
    const file = devicesHelpers.getDevicesCsvFile(data.apartments)
    const blob = new Blob([bom + file], { type: 'text/csv' })
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = `Mätare ${data.name} ${helpers.getDateTimeString(new Date())}.csv`
    link.click()
    URL.revokeObjectURL(link.href)
}

async function exportBaseDataToFile() {
    const options = {
        fontFamily: 'Calibri',
        fontSize: 11,
        dateFormat: 'yyyy-mm-dd',
        headerStyle: {
            backgroundColor: '#c0c0c0',
            align: 'center',
            fontSize: 11,
            verticalAlign: 'middle',
        },
        schema: [{
            column: 'Mätplatsnummer',
            type: String,
            width: 20,
            value: apt => apt.number
        }, {
            column: 'Adress',
            type: String,
            width: 25,
            value: apt => apt.address
        }, {
            column: 'Typ',
            type: String,
            width: 12,
            value: apt => apt.type
        }, {
            column: 'Externt nummer',
            type: String,
            width: 20,
            value: apt => apt.externalNumber
        }, {
            column: 'Hustyp',
            type: String,
            width: 15,
            value: apt => apt.buildingType
        }, {
            column: 'Andel',
            type: Number,
            width: 15,
            value: apt => apt.share
        }, {
            column: 'Nytt mätplatsnummer',
            type: String,
            width: 20,
            value: _apt => ''
        }, {
            column: 'Ta bort?',
            type: String,
            width: 10,
            value: _apt => ''
        }],
        fileName: 'Grunddata ' + data.name + ' ' + new Date().toLocaleDateString('sv-SE') + '.xlsx',
    }

    const baseData = (await sitesService.getBaseData(data.siteId)).data

    await writeXlsxFile(baseData, options)
}

async function exportOneReaderMeterListToFile() {
    const options = {
        fontFamily: 'Calibri',
        fontSize: 11,
        dateFormat: 'yyyy-mm-dd',
        schema: [{
            type: String,
            width: 12,
            value: d => String(d.idNumber)
        }, {
            type: String,
            width: 40,
            value: d => String(d.aesKey ?? "")
        }, {
            type: String,
            width: 40,
            value: d => d.name
        }, {
            type: Number,
            width: 4,
            value: d => d.index
        }],
        fileName: 'Mätarlista ' + data.name + ' ' + new Date().toLocaleDateString('sv-SE') + '.xlsx',
    }
    const deviceTypes = { 1: 'KV', 2: 'VV', 3: 'VÄ', 4: 'EL', 5: 'RM', 6: 'RUM', 7: 'KYL' }
   
    const devices = (await sitesService.getDeviceData(data.siteId)).data
    devices.sort((a, b) => String(a.apartmentNumber).localeCompare(String(b.apartmentNumber)))
    let lastType = null, hasMultipleTypes = false
    for (let i = 0; i < devices.length; i++) {
        devices[i].index = i + 1
        if (lastType === null) {
            lastType = devices[i].mpType
        } else if (!hasMultipleTypes && lastType != devices[i].mpType) {
            hasMultipleTypes = true
        }
    }
    for (const d of devices) {
        d.name = `${(hasMultipleTypes && deviceTypes[d.mpType]) ? deviceTypes[d.mpType] + ' ' : ''}${d.address ? d.address : d.apartmentNumber}`
    }

    await writeXlsxFile(devices, options)
}

function onShowDeviceReadings(args) {
    readingsData.apartmentId = args.apartmentId
    onReadingsChangeApartment(args.deviceId)
    readingsModal.show()
}

function onReadingsChangeApartment(deviceId = null) {
    const apartment = data.apartments.find(a => a.id == readingsData.apartmentId)
    if (apartment) {
        readingsData.devices = apartment.devices
        if (apartment.devices.length === 1) {
            readingsData.deviceId = apartment.devices[0].deviceId
            onReadingsUpdate(apartment.devices[0].measurement)
        } else if (deviceId) {
            readingsData.deviceId = deviceId
            onReadingsUpdate(apartment.devices.find(d => d.deviceId == deviceId).measurement)
        }
    }
}

async function onReadingsUpdate(measurement) {
    if (!readingsData.deviceId) {
        return
    }

    const data = (await readingsService.getDeviceReadings(
        readingsData.deviceId, 
        readingsData.start, 
        readingsData.stop
    )).data

    const array = []
    for (const timestamp in data) {
        array.push({
            timestamp,
            fields: data[timestamp],
            source: data[timestamp].source ?? null
        })
    }
    array.sort((a, b) => a.timestamp < b.timestamp ? 1 : -1)

    const fields = []
    if (array.length > 0) {
        for (const field in array[0].fields) {
            if (field === 'source') {
                continue
            }
            fields.push(field)
        }
    }

    readingsData.readings = array
    readingsData.fields = fields
    readingsData.hasMore = array.length >= 100
    if (measurement) {
        readingsData.mpFields = seriesHelpers.getMeasurementFields(measurement)
    }    
}

async function loadDocuments() {
    data.documents = (await documentsService.getDocuments(data.siteId)).data

    reportsData.types = [
        'Kallvatten',
        'Varmvatten',
        'Temperaturgivare',
        'Integreringsverk',
    ]
    certificatesData.types =[
        'Massflöde',
        'Volym',
        'Kallvatten',
        'Varmvatten',
    ]

    filterDocuments()
}

async function filterDocuments() {
    let hasCertificates = false

    reportsData.documents = []
    certificatesData.documents = []

    for (const doc of data.documents) {
        const downloadLines = []
        doc.downloads.forEach(dl => downloadLines.push(`${new Date(dl.timestamp).toLocaleString('sv')} ${dl.name} (${dl.email})`))

        const type = doc.tags && doc.tags.length > 1 ? doc.tags[1] : ''

        const row = {
            id: doc.id,
            filename: doc.filename,
            created: doc.created,
            period: doc.period,
            type,
            isDownloaded: doc.isDownloaded,
            downloadsCount: doc.downloads.length,
            downloadsTitle: downloadLines.join('\n')
        }

        if (doc.tags.includes('Kontroll ISO/IEC 17020:2012')) {
            if ((reportsData.period === 'all' || reportsData.period === doc.period) &&
                (reportsData.type === 'all' || doc.tags.includes(reportsData.type))
            ) {
                reportsData.documents.push(row)
            }
        } else if (doc.tags.includes('Kalibrering ISO/IEC 17025:2018')) {
            if ((certificatesData.period === 'all' || certificatesData.period === doc.period) &&
                (certificatesData.type === 'all' || doc.tags.includes(certificatesData.type))
            ) {
                certificatesData.documents.push(row)
            }
            hasCertificates = true
        }
    }
    data.hasCertificates = hasCertificates
}

onMounted(async () => {
    const res = await sitesService.getSite(route.params.id)

    // Initiate data
    data.siteId = res.data.id
    data.name = res.data.name
    data.properties = res.data.properties ?? {}
    data.user = tokenService.getUser()
    loadDocuments()

    // Get references to modals
    apiKeysModal = new Modal(document.getElementById('apiKeysModal'))
    importModal = new Modal(document.getElementById('importModal'))
    resultModal = new Modal(document.getElementById('resultModal'))
    apartmentModal = new Modal(document.getElementById('apartmentModal'))
    readingsModal = new Modal(document.getElementById('readingsModal'))
    importReadingsModal = new Modal(document.getElementById('importReadingsModal'))
    uploadDocumentModal = new Modal(document.getElementById('uploadDocumentModal'))
    baseDataImportModal = new Modal(document.getElementById('baseDataImportModal'))

    // Initiate statistics tab form
    let now = new Date()
    statisticsData.site = res.data.id
    statisticsData.date = now.toISOString().substring(0, 10)
    statisticsData.year = now.getFullYear().toString()
    statisticsData.month = now.getMonth().toString()
    statisticsData.week = dateTime.getWeekNumber(now).toString()
    statisticsData.period = 'daysMonth'

    // Initate import log tab
    importLogData.siteId = res.data.id
    importLogData.start = dateTime.floor(new Date(), 'day')
    importLogData.stop = dateTime.add(importLogData.start, 'day', 1)
    
    reload()
})
</script>